import CustomerDataFragment from "@buzzeasy/customer-data-fragment-2";
import { FC, memo, useCallback} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { getEnvSettings } from "../../../app/hostBasedSettings";
import { IWorkItem } from "../../../models/BlenderAgentStateModel";
import { setConversationData } from "../../../redux/apis/workflowManagerApiSlice";
import { useAppDispatch, useAppSelector} from "../../../redux/hooks";
import { selectAuth } from "../../../redux/slices/authSlice";
import { addCustomerName } from "../../../redux/slices/consolePageSlice";
import { dxpLayout } from "../../../style/theme";
import { Customer } from "../../../models/CustomerModel";
import { message } from 'antd';

interface IProps {
  workItem: IWorkItem;
}

const RootContainer = styled.div`
  width: 100%;
  height: calc(100% - ${dxpLayout.workItemHeaderHeight});
`;

const CustomerDataPanel: FC<IProps> = memo(({ workItem }) => {
  const dispatch = useAppDispatch();
  const { token } = useSelector(selectAuth);
  const envSettings = getEnvSettings();
  const [messageApi, contextHolder] = message.useMessage();
  const hideInfo = useAppSelector(
    (state) => state.blenderState.agentClientState.agentProperties.displaySettings.hideSensitiveAgentInformation
  );

  const onCustomerSwap = useCallback(
    (newCustomerId: string) => {
      dispatch(
        setConversationData(token, workItem.primaryConversationId, [
          { key: "CustomerId", value: newCustomerId },
        ])
      );
    },
    [dispatch, token, workItem.primaryConversationId]
  );
  
  const onCustomerChange = useCallback(
    (customer: Customer) => {
      dispatch(
        addCustomerName({
          id: customer.customerId,
          name: customer.firstName,
        })
      );
    },
    [dispatch]
  );

  return (
    <RootContainer>
      <CustomerDataFragment
        apiBaseUrl={envSettings.apiBaseURL}
        businessUnitId={workItem.businessUnitId}
        customerId={workItem.customerId}
        token={token}
        onSwapCustomer={onCustomerSwap}
        onCustomerRetrieved={onCustomerChange}
        featureFlags={{hideSensitiveAgentInformation:hideInfo}}
        messageApi={messageApi}
      />
      {contextHolder}
    </RootContainer>
  );
});

export default CustomerDataPanel;
